import React, {useCallback, useContext, useEffect, useState} from "react";
import Tabs from "common/components/Tabs";
import AdminApi from "common/api";
import {AlertContext} from "context/AlertContext";
import {Form} from "react-bootstrap";
import EventSettings from "./eventSettings";
import RoundManagement from "./rounds";
import TeamManagement from "./teams";
import MatchManagement from "./matches";

export default function WorldcupTab() {
  const api = new AdminApi();
  const {setShow, setToastMsg} = useContext(AlertContext);

  const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [event, setEvent] = useState(null);
  const [rounds, setRounds] = useState([]);
  const [teams, setTeams] = useState([]);

  const refreshEvents = useCallback(() => {
    return api.getWorldcupEvents().then((res) => {
      if (res?.result === "ok") {
        setEvents(res.events ?? []);
        return res.events ?? [];
      }
      return [];
    });
  }, []);

  const refreshEventDetail = useCallback((eventId) => {
    if (!eventId) {
      setEvent(null);
      setRounds([]);
      setTeams([]);
      return Promise.resolve();
    }
    return Promise.all([
      api.getWorldcupEvent(eventId),
      api.getWorldcupRounds(eventId),
      api.getWorldcupTeams(eventId),
    ]).then(([eventRes, roundsRes, teamsRes]) => {
      if (eventRes?.result === "ok") setEvent(eventRes.event);
      if (roundsRes?.result === "ok") setRounds(roundsRes.rounds ?? []);
      if (teamsRes?.result === "ok") setTeams(teamsRes.teams ?? []);
    });
  }, []);

  useEffect(() => {
    refreshEvents().then((list) => {
      if (list.length === 0) return;
      const active = list.find((e) => e.status === "ACTIVE") ?? list[0];
      setSelectedEventId(active.eventId);
    });
  }, [refreshEvents]);

  useEffect(() => {
    refreshEventDetail(selectedEventId);
  }, [selectedEventId, refreshEventDetail]);

  function onEventChanged(eventId) {
    setSelectedEventId(eventId);
    refreshEvents();
  }

  function notify(msg, shouldRefresh = true) {
    setToastMsg(msg);
    setShow(true);
    if (shouldRefresh && selectedEventId) {
      refreshEventDetail(selectedEventId);
    }
  }

  const sharedProps = {
    api,
    eventId: selectedEventId,
    event,
    rounds,
    teams,
    onRefresh: () => refreshEventDetail(selectedEventId),
    notify,
  };

  return (
    <div className="worldcup-admin">
      <h1>월드컵 예측 이벤트</h1>

      <div className="worldcup-event-picker flex" style={{marginTop: 24, marginBottom: 8}}>
        <span style={{fontWeight: 700, marginRight: 16}}>이벤트 선택</span>
        {events.length > 0 ? (
          <Form.Select
            style={{maxWidth: 360}}
            value={selectedEventId ?? ""}
            onChange={(e) => setSelectedEventId(Number(e.target.value))}
          >
            {events.map((item) => (
              <option key={item.eventId} value={item.eventId}>
                [{item.status}] {item.title} (#{item.eventId})
              </option>
            ))}
          </Form.Select>
        ) : (
          <span>등록된 이벤트가 없습니다. 이벤트 설정 탭에서 생성해주세요.</span>
        )}
      </div>

      <Tabs
        className="worldcup-tabs"
        tabNames={["이벤트 설정", "라운드", "팀 관리", "경기 관리"]}
        tabPages={[
          <EventSettings
            key="event"
            events={events}
            selectedEventId={selectedEventId}
            onEventChanged={onEventChanged}
            refreshEvents={refreshEvents}
            {...sharedProps}
          />,
          <RoundManagement key="rounds" {...sharedProps} />,
          <TeamManagement key="teams" {...sharedProps} />,
          <MatchManagement key="matches" {...sharedProps} />,
        ]}
      />
    </div>
  );
}
